export default __webpack_public_path__ + "static/media/zar.7cbec7b8.png";